export const ImageUrlToFile = async (imageUrl) => {
  if (!imageUrl) {
    console.error("Image URL is empty");
    return null;
  }

  try {
    const response = await fetch(imageUrl, { redirect: "follow" });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch image: ${response.status} ${response.statusText}`
      );
    }
    const contentType = response.headers.get("Content-Type");

    if (!contentType || !contentType.startsWith("image/")) {
      return null;
    }

    const blob = await response.blob();

    // Map MIME types to valid file extensions
    const extensionMap = {
      "image/jpeg": "jpg",
      "image/png": "png",
      "image/gif": "gif",
      "image/webp": "webp",
      "image/bmp": "bmp",
      "image/tiff": "tif",
    };

    const extension = extensionMap[contentType] || "jpg";

    let extractedFilename = imageUrl.split("/").pop()?.split("?")[0];

    if (!extractedFilename || extractedFilename.trim() === "") {
      extractedFilename = "downloaded-image";
    }

    if (!extractedFilename.includes(".")) {
      extractedFilename += `.${extension}`;
    } else {
      const parts = extractedFilename.split(".");
      const baseName = parts.slice(0, -1).join(".");
      const existingExt = parts[parts.length - 1].toLowerCase();
      if (!Object.values(extensionMap).includes(existingExt)) {
        extractedFilename = `${baseName}.${extension}`;
      }
    }

    return new File([blob], extractedFilename, { type: contentType });
  } catch (error) {
    return null;
  }
};
// export const ImageUrlToFile = async (imageUrl) => {
//   if (!imageUrl) {
//     return null;
//   } else {
//     try {
//       const response = await fetch(imageUrl);
//       const blob = await response.blob();
//       return new File([blob], "converted-image.jpg", { type: blob.type });
//     } catch (error) {
//       console.error("Error converting image:", error);
//       return null;
//     }
//   }
// };
